//Componentes generales
import React, { useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Routes_gral from "../../utils/Routes_gral";
import "react-phone-input-2/lib/style.css";


//Imagenes
import logoG4 from "../../images/LOGO-BLANCO.png";

//Estilos
import "./ConfirmEmail.css";

//Contexto
import authContext from "../../context/authentication/authContex";

function ConfirmEmail(props) {
  const aContext = useContext(authContext);
  const { confirmarEmail, resendConfirmationEmail } = aContext;

  const navigate = useNavigate();
  const params = useParams();
  const [stepper, setStepper] = useState(1);
  const [error, setError] = useState("");

  const onSubmit = async () => {
    try {
      await confirmarEmail(params.token.toString());
      setStepper(2);
    } catch (error) {
      console.log("ERROR EN CONFIRMAR EMAIL", error);

      const mensajeError = String(
        error?.response?.data?.message ||
          error?.response?.data?.msg ||
          error?.message ||
          "Error desconocido."
      );
      setError(mensajeError);

      setStepper(3);
    }
  };

  const handleRecoverPassword = async () => {
    navigate(Routes_gral.recoverPassword);
  };

  const onLogin = async () => {
    navigate(Routes_gral.login);
  };

  return (
    <div className="container-registro">
      <div className="card-registro">
        {stepper === 1 ? (
          <>
            <div className="containerRegistroTitulo">
              <h2>Confirmar cuenta</h2>
            </div>
            <div>
              <h3>Ya casi estamos!</h3>
              <p>Haz click en el siguiente botón:</p>
            </div>
            <div style={{ width: "400px", textAlign: "center" }}>
              <button
                id="myBtn"
                className="btnStyle btnSubmit"
                onClick={onSubmit}
              >
                Confirmar correo
              </button>
            </div>
          </>
        ) : stepper == 2 ? (
          <>
            <div style={{ textAlign: "center" }}>
              <h2>¡Todo listo!</h2>
              <p>¡Puedes comenzar a disfrutar nuestra plataforma!</p>
            </div>
            <div>
              <button
                id="myBtn"
                className="btnStyle btnLogin"
                onClick={onLogin}
              >
                Ingresar
              </button>
            </div>
          </>
        ) : stepper === 3 ? (
          <>
            <div style={{ textAlign: "center" }}>
              <h2>Ocurrió un error!</h2>
              <p>{error}</p>
              <p>
                Si necesitas recuperar tu cuenta haz click en el siguiente
                botón:
              </p>
              <button
                id="myBtn"
                className="btnSubmitStyle"
                onClick={handleRecoverPassword}
              >
                Recuperar contraseña
              </button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default ConfirmEmail;